import type { TagsLabelItem } from '../../4-sections/SearchSection/SearchBlockContext';
import { type SearchItemTagProps } from '4-sections/SearchSection/SearchItem';

export const CONTENT_TYPES = [
    'ArticlePage',
    'AssetPage',
    'AssetListingPage',
    'ArticleListingPage',
    'PersonPage',
    'LocationPage',
    // 'StandardPage',
    'PdfFile'
];


export const resolveContentTypeToSearchItemTags = (contentType: string[] | null, tagsLabel?: TagsLabelItem[]): SearchItemTagProps[] => {
    if (!contentType) {
        return [];
    }

    const tags: SearchItemTagProps[] = [];
    CONTENT_TYPES.forEach(pageType => {
        const contentTypeResult = contentType.find(value => {
            return value === pageType;
        });

        if (contentTypeResult) {
            const label = tagsLabel ? tagsLabel.find(({ value }) => {
                return value === contentTypeResult;
            })?.label || contentTypeResult : contentTypeResult;
            tags.push({ label });
        }
    });

    return tags;
};

export const resolveAncestorToSearchItemTags = (ancestors: string[] | null, ancestorsTagsLabel?: TagsLabelItem[]): SearchItemTagProps[] => {
    if (!ancestors) {
        return [];
    }

    const tags: SearchItemTagProps[] = [];
    ancestors.forEach(ancestor => {
        const foundAncestor = ancestorsTagsLabel?.find(({ value }) => {
            return value === ancestor;
        });

        if (foundAncestor) {
            tags.push({ label: foundAncestor.label });
        }
    });

    return tags;
};
